import React from 'react';

interface CustomSwitchProps {
    checked?: boolean;
    onChange?: (checked: boolean, event: React.MouseEvent<HTMLButtonElement>) => void;
    checkedChildren?: React.ReactNode;
    unCheckedChildren?: React.ReactNode;
    disabled?: boolean;
    className?: string;
    style?: React.CSSProperties;
}

const CustomSwitch = ({
    checked = false,
    onChange,
    checkedChildren,
    unCheckedChildren,
    disabled = false,
    className = '',
    style,
}: CustomSwitchProps) => {
    return (
        <button
            type="button"
            role="switch"
            aria-checked={checked}
            disabled={disabled}
            style={style}
            className={`cs-switch ${checked ? 'cs-switch--checked' : ''} ${className}`.trim()}
            onClick={(e) => !disabled && onChange?.(!checked, e)}
        >
            <span className="cs-switch__handle" />
            <span className="cs-switch__inner">
                {checked ? checkedChildren : unCheckedChildren}
            </span>
        </button>
    );
};

export default CustomSwitch;